import CartReviewCard from "./components/CartReviewCard";
import CartReviewItem from "./components/CartReviewItem";
import CartReviewLine from "./components/CartReviewLine";

export default {
  Card: CartReviewCard,
  Item: CartReviewItem,
  Line: CartReviewLine,
};

export type { CartReviewProduct } from "./types";
